import o from "./ghl-ui.es1133.js";
const t = (e) => ({
  dotSize: "8px",
  dotColor: "rgba(255, 255, 255, .3)",
  dotColorActive: "rgba(255, 255, 255, 1)",
  dotColorFocus: "rgba(255, 255, 255, .5)",
  dotLineWidth: "16px",
  dotLineWidthActive: "24px",
  arrowColor: "#eee"
}), r = {
  name: "Carousel",
  common: o,
  self: t
}, i = r;
export {
  i as default,
  t as self
};
